var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roster-cell roster-cell--overtime"},[_c('p',{staticClass:"roster-cell__value"},[_c('span',[_vm._v(_vm._s(_vm.overTimeResult[_vm.index]))])])])}
var staticRenderFns = []

export { render, staticRenderFns }